import React from "react";
import MobileTitleOthersData from "./TitleOthers";

function MobileOthers({ Data, getData, projectList, projectId ,itemsCategory,Activity,Division,Unit}) {
  

  return (
    <div className=" w-full  h-[70vh] overflow-y-auto">
      {Data &&
        Data.map((item, idx) => {
          return (
            <MobileTitleOthersData rowData={item} key={idx} getData={getData} projectList={projectList} projectId={projectId} itemsCategory={itemsCategory}  Activity={Activity} Division={Division} Unit={Unit} />
          );
        })}
    </div>
  );
}

export default MobileOthers;